import { render } from "./CreateServiceReport1.vue?vue&type=template&id=58bfe2f8"
import script from "./CreateServiceReport1.vue?vue&type=script&lang=js"
export * from "./CreateServiceReport1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__